import controlArrows from "./controlArrows.js";
import createDays from "./createDays.js";
import showMonth from "./showMonth.js";
import showYear from "./showYear.js";
const changeMonth = (self, route) => {
  if (self.selectedMonth === void 0 || self.selectedYear === void 0) return;
  const lastMonth = self.locale.months.length - 1;
  switch (route) {
    case "prev":
      if (self.selectedMonth !== 0) {
        self.selectedMonth -= 1;
      } else if (self.settings.selection.year) {
        self.selectedYear -= 1;
        self.selectedMonth = lastMonth;
      }
      break;
    case "next":
      if (self.selectedMonth !== lastMonth) {
        self.selectedMonth += 1;
      } else if (self.settings.selection.year) {
        self.selectedYear += 1;
        self.selectedMonth = 0;
      }
      break;
  }
  showMonth(self);
  showYear(self);
  controlArrows(self);
  createDays(self);
};
export {
  changeMonth as default
};
